import { apiClient } from './api'

// ── Types ──────────────────────────────────────────────────────────────────

export type GithubRepoConfig = {
  owner: string
  repo: string
  sync_issues: boolean
}

export type GithubIntegrationConfig = {
  id: string
  repositories: GithubRepoConfig[]
  project_number: number | null
  project_owner: string | null
  project_owner_type: 'organization' | 'user' | null
  column_mapping: Record<string, string> | null
  label_space_mapping: Record<string, string> | null
  label_type_mapping: Record<string, string> | null
  label_priority_mapping: Record<string, string> | null
  is_active: boolean
  last_sync_at: string | null
  last_sync_status: string | null
  last_sync_error: string | null
  has_token: boolean
  has_webhook_secret: boolean
  created_at: string
  updated_at: string
}

export type CreateGithubIntegrationInput = {
  personal_access_token: string
  webhook_secret?: string
  repositories?: GithubRepoConfig[]
  project_number?: number
  project_owner?: string
  project_owner_type?: 'organization' | 'user'
  column_mapping?: Record<string, string>
  label_space_mapping?: Record<string, string>
  label_type_mapping?: Record<string, string>
  label_priority_mapping?: Record<string, string>
  is_active?: boolean
}

export type UpdateGithubIntegrationInput = {
  personal_access_token?: string
  webhook_secret?: string
  repositories?: GithubRepoConfig[]
  project_number?: number
  project_owner?: string
  project_owner_type?: 'organization' | 'user'
  column_mapping?: Record<string, string>
  label_space_mapping?: Record<string, string>
  label_type_mapping?: Record<string, string>
  label_priority_mapping?: Record<string, string>
  is_active?: boolean
}

export type GithubSyncResult = {
  status: string
  issues_created: number
  issues_updated: number
  comments_synced: number
  roadmap_synced: number
  error?: string
}

export type GithubTestConnectionResult = {
  success: boolean
  username?: string
  error?: string
}

// ── API ────────────────────────────────────────────────────────────────────

const BASE = '/api/v1/github-integration'

export const githubIntegrationApi = {
  getConfig: () => apiClient.get<GithubIntegrationConfig>(`${BASE}/config`),

  createConfig: (data: CreateGithubIntegrationInput) =>
    apiClient.post<GithubIntegrationConfig>(`${BASE}/config`, data),

  updateConfig: (data: UpdateGithubIntegrationInput) =>
    apiClient.put<GithubIntegrationConfig>(`${BASE}/config`, data),

  deleteConfig: () => apiClient.delete(`${BASE}/config`),

  triggerSync: () => apiClient.post<GithubSyncResult>(`${BASE}/sync`),

  testConnection: () => apiClient.post<GithubTestConnectionResult>(`${BASE}/test`),
}

export default githubIntegrationApi
